<template>
  <el-footer class="el-footer-wrap"
             v-if="appInfoNew.domainSubject"
             height="32px">
    <p>系统建设方：{{ appInfoNew.domainSubject }}</p>
  </el-footer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'layout-footer',
  computed: {
    ...mapState({
      appInfoNew: state => state.account.appInfoNew
    })
  }
}
</script>
<style lang="stylus">
.el-footer-wrap {
  text-align: center;
  font-size: 13px;
  padding: 3px;
  color: #666;
  background: #f9f9f9;
}
</style>
